import { Badge, Card, FontIcon, Typography } from "@ezmid/components-library";
import { faFingerprint, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { EntityPayment } from "../../../api/payments.generated";

type Props = {
  currentData?: EntityPayment;
};

export function PaymentCard({ currentData }: Props) {
  const { t } = useTranslation();
  const status =
    currentData?.status === "ps-purchased"
      ? "success"
      : currentData?.status === "ps-canceled"
      ? "danger"
      : "warning";
  return (
    <Card
      margin={2}
      shadows="xl"
      size="sm"
      hasBorder={false}
      headerText={t("payment.informations")}
      headerIcon={
        <FontIcon
          marginTop={4}
          customIcon={<FontAwesomeIcon size="lg" icon={faInfoCircle} />}
        />
      }
    >
      <div className="p-4">
        <div className="flex items-center mb-4" />
        <div className="flex items-center mb-2 max-h-48">
          <p className="font-bold mr-2">{t("payment.id")}:</p>
          <Badge
            variant="pill"
            leftIcon={
              <FontIcon
                marginTop={4}
                customIcon={<FontAwesomeIcon size="lg" icon={faFingerprint} />}
              />
            }
          >
            {currentData?.id?.toUpperCase().substr(0, 8)}
          </Badge>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.apple.receipt")}:</p>
          <Typography variant="body1">
            {currentData?.appleTransactionID}
          </Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.apple.transaction.id")}:</p>
          <Badge
            variant="pill"
            leftIcon={
              <FontIcon
                marginTop={3}
                customIcon={<FontAwesomeIcon size="lg" icon={faFingerprint} />}
              />
            }
          >
            {currentData?.appleTransactionID?.toUpperCase().substr(0, 8)}
          </Badge>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.vendor.label")}:</p>
          <Typography variant="body1">{currentData?.paymentVendor}</Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.priceCurrencyCode")}:</p>
          <Typography variant="body1">
            {currentData?.priceCurrencyCode}
          </Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.priceMicros")}:</p>
          <Typography variant="body1">{currentData?.priceMicros}</Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{t("payment.status")}:</p>
          <Badge status={status} variant="pill">
            {currentData?.status}
          </Badge>
        </div>
        <div className="flex items-start mb-2">
          <p className="font-bold mr-2 shrink-0">{t("payment.vendor.id")}:</p>
          <div className="min-w-0 break-all [&_*]:!whitespace-normal">
            <Badge
              variant="pill"
              leftIcon={
                <FontIcon
                  marginTop={3}
                  customIcon={
                    <FontAwesomeIcon size="lg" icon={faFingerprint} />
                  }
                />
              }
            >
              {currentData?.vendorProductID}
            </Badge>
          </div>
        </div>
        <div className="flex items-center">
          <p className="font-bold mr-2">{t("payment.google.order.id")}:</p>
          <Badge
            variant="pill"
            leftIcon={
              <FontIcon
                marginTop={3}
                customIcon={<FontAwesomeIcon size="lg" icon={faFingerprint} />}
              />
            }
          >
            {currentData?.googleOrderID?.toUpperCase().substr(0, 8)}
          </Badge>
        </div>
      </div>
    </Card>
  );
}
